import { render, staticRenderFns } from "./ActionNotification.vue?vue&type=template&id=8f5e8052&scoped=true"
import script from "./ActionNotification.vue?vue&type=script&lang=ts"
export * from "./ActionNotification.vue?vue&type=script&lang=ts"
import style0 from "./ActionNotification.vue?vue&type=style&index=0&id=8f5e8052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5e8052",
  null
  
)

export default component.exports